import { PlusIcon } from "@xola/icons";
import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import { orderBy } from "lodash";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Membership, Permission } from "types";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { ExperienceSearch } from "../../components/Product/ExperienceSearch";
import { useAutoFetchCollection } from "../../hooks/useAutoFetchCollection";
import { useSearch } from "../../hooks/useSearch";
import { Page } from "../Page";
import { IsGranted } from "@/components/Common/IsGranted";
import { MembershipList } from "@/components/Product/Membership/MembershipList";

export const MembershipListPage = () => {
    const [search, setSearch] = useState("");
    const { data: memberships, isLoading } = useAutoFetchCollection<Membership>("memberships");
    let filtered = useSearch(memberships, (membership) => [membership.name, membership.id], search);
    filtered = orderBy(filtered, (membership) => membership.name, ["asc"]);
    const isFiltered = search.length > 0;
    const history = useHistory();

    const handleCreateProductClick = () => {
        history.push("/products/memberships/new");
    };

    const handleGlobalSettingsClick = () => {
        history.push("/products/memberships/globalSettings/questionnaire");
    };

    return (
        <Page title="Memberships">
            <ColumnLayout>
                <HeaderToolbar className="justify-between">
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Products</Breadcrumb.Item>
                        <Breadcrumb.Item>Memberships</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <ExperienceSearch onSearch={setSearch} />
                    <IsGranted permissions={Permission.MEMBERSHIPS_MODIFY}>
                        <SecondaryButton className="flex-shrink-0" onClick={handleGlobalSettingsClick}>
                            Global Settings
                        </SecondaryButton>
                        <Button className="flex-shrink-0" icon={<PlusIcon />} onClick={handleCreateProductClick}>
                            Create Membership
                        </Button>
                    </IsGranted>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <MembershipList memberships={filtered} isLoading={isLoading} isFiltered={isFiltered} />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
